import {asInt, getFirstQueryValue} from "~/utils/queryValues";

export default () => {
  const router = useRouter();
  return ref<number>(
    asInt(getFirstQueryValue(router.currentRoute.value.query.page)) ?? 1,
  );
};
